import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateState, exchangeCodeForToken, getUserInfo, storeAuthData } from '../utils/auth';
import './Callback.css';

function Callback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Parse URL parameters
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const errorParam = params.get('error');

        // Check for OAuth error
        if (errorParam) {
          throw new Error(`OAuth Error: ${errorParam} - ${params.get('error_description')}`);
        }

        // Validate required parameters
        if (!code || !state) {
          throw new Error('Missing authorization code or state parameter');
        }

        // Validate state for CSRF protection
        if (!validateState(state)) {
          throw new Error('Invalid state parameter - possible CSRF attack');
        }

        setStatus('exchanging');

        // Exchange code for token (backend API call)
        const tokenData = await exchangeCodeForToken(code);

        setStatus('fetching-user');

        // Get user information
        const userInfo = await getUserInfo(tokenData.access_token);

        // Store authentication data
        storeAuthData({
          access_token: tokenData.access_token,
          refresh_token: tokenData.refresh_token,
          user: userInfo,
        });

        setStatus('success');

        // Redirect to home page
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 1000);

      } catch (err) {
        console.error('Authentication error:', err);
        setError(err.message);
        setStatus('error');

        // Redirect to login after delay
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="callback-container">
      <div className="callback-card">
        {status === 'processing' && (
          <>
            <div className="spinner"></div>
            <h2>인증 처리 중...</h2>
            <p>잠시만 기다려주세요</p>
          </>
        )}

        {status === 'exchanging' && (
          <>
            <div className="spinner"></div>
            <h2>토큰 교환 중...</h2>
            <p>인증 정보를 확인하고 있습니다</p>
          </>
        )}

        {status === 'fetching-user' && (
          <>
            <div className="spinner"></div>
            <h2>사용자 정보 가져오는 중...</h2>
            <p>프로필 정보를 불러오고 있습니다</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>로그인 성공!</h2>
            <p>메인 페이지로 이동합니다...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="error-icon">✕</div>
            <h2>로그인 실패</h2>
            <p className="error-message">{error}</p>
            <p>로그인 페이지로 돌아갑니다...</p>
          </>
        )}
      </div>
    </div>
  );
}

export default Callback;
